import {pixels} from '../../abstract-units';
import {BoxEdge} from '../../edge';
import {CellAreaDefinition} from '../area-definition';
import {CellAreaType} from '../cell-area-type';
import {CELL_SIZE, EDGE_AREA_THICKNESS_PX, ZERO_POS} from './common';

const thickness = pixels(EDGE_AREA_THICKNESS_PX);
const bluntAnglePos = (totalPx: number) => totalPx - EDGE_AREA_THICKNESS_PX;

export const RIGHT_EDGE_CELL_AREA_DEF: CellAreaDefinition = {
    type: CellAreaType.EDGE,
    boxEdge: BoxEdge.RIGHT,
    vertices: [
        [bluntAnglePos, thickness],     [CELL_SIZE, ZERO_POS], // TOP_LEFT, TOP_RIGHT
        [bluntAnglePos, bluntAnglePos], [CELL_SIZE, CELL_SIZE] // BOTTOM_LEFT, BOTTOM_RIGHT
    ]
};
